import { render, staticRenderFns } from "./ticketingUserIssueList.vue?vue&type=template&id=07fa5903"
import script from "./ticketingUserIssueList.vue?vue&type=script&lang=js"
export * from "./ticketingUserIssueList.vue?vue&type=script&lang=js"
import style0 from "./ticketingUserIssueList.vue?vue&type=style&index=0&id=07fa5903&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports